import { cn } from "@/lib/utils";
import type { BookingLineItemChip } from "./sellerBookingRules";

interface BookingLineItemChipsProps {
  items: BookingLineItemChip[];
  className?: string;
}

export function BookingLineItemChips({
  items,
  className,
}: BookingLineItemChipsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex flex-wrap gap-1.5", className)}>
      {items.map((item) => (
        <span
          key={item.id}
          className="inline-flex max-w-full items-start rounded-md border border-surface-200 bg-surface-50 px-2 py-0.5 text-xs font-medium leading-snug text-surface-700"
        >
          <span className="mr-1 shrink-0 text-surface-500">{item.quantity}×</span>
          <span className="min-w-0 break-words">{item.name}</span>
        </span>
      ))}
    </div>
  );
}
